(function () {
  'use strict';

  var lastViewedKey = '';
  var lastViewedAt = 0;
  var lastPayNowAt = 0;

  function ensureDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function getCurrency() {
    return window.Shopify?.currency?.active || window.Shopify?.Checkout?.currency || 'INR';
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getText(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function getTitleFromValue(value) {
    var text = getText(value);
    if (!text) return '';
    return text.split('/')[0] || text;
  }

  function getPartsFromValue(value) {
    var text = getText(value);
    if (!text) return [];
    return text.split('/');
  }

  function normalizePrice(value) {
    var amount = toNumber(value, 0);
    return amount > 999 ? amount / 100 : amount;
  }

  function getCollectionItemTitle(node) {
    var collectionItem = node && typeof node.closest === 'function' ? node.closest('.collection-item') : null;
    var titleNode = collectionItem ? collectionItem.querySelector('.product_flexi_title') : null;
    return getText(titleNode && titleNode.textContent);
  }

  function buildItemFromElement(element, overrides) {
    var node = element || {};
    var dataset = node.dataset || {};
    var valueParts = getPartsFromValue(node.value);
    var title =
      getText(overrides && overrides.item_name) ||
      getText(dataset.productTitle) ||
      getText(dataset.title) ||
      valueParts[0] ||
      getCollectionItemTitle(node) ||
      '';
    var itemId =
      getText(overrides && overrides.item_id) ||
      getText(dataset.variantId) ||
      getText(valueParts[2]) ||
      getText(dataset.sku) ||
      getText(dataset.productId) ||
      title;

    return {
      item_id: itemId,
      item_name: title,
      item_variant: getText(overrides && overrides.item_variant) || getText(dataset.variantId) || getText(valueParts[2]),
      item_brand: getText(overrides && overrides.item_brand) || getText(dataset.vendor),
      item_category: getText(overrides && overrides.item_category) || getText(dataset.productType),
      item_list_name: getText(overrides && overrides.item_list_name) || 'Bundle Builder',
      item_list_id: getText(overrides && overrides.item_list_id) || 'flexi_bundle',
      price: normalizePrice(overrides && overrides.price !== undefined ? overrides.price : dataset.price),
      quantity: toNumber(overrides && overrides.quantity, 1),
      product_id: getText(overrides && overrides.product_id) || getText(dataset.productId),
      sku: getText(overrides && overrides.sku) || getText(dataset.sku) || getText(valueParts[1]),
    };
  }

  function getBundleRoot() {
    return document.querySelector('.flexi-box-bundle');
  }

  function getBundleForm() {
    return document.getElementById('flexi-box-form');
  }

  function getBundleName() {
    var title = document.querySelector('.heading-new-bogo');
    if (title) return getText(title.textContent);
    return '';
  }

  function getBundleContext() {
    var root = getBundleRoot();
    var form = getBundleForm();

    return {
      bundle_id: getText(form && form.dataset && form.dataset.variantId),
      bundle_name: getBundleName(),
      bundle_price: toNumber(form && form.dataset && form.dataset.price, 0),
      bundle_sku: getText(form && form.dataset && form.dataset.sku),
      parent_product_id: getText(root && root.dataset && root.dataset.productId),
      parent_product_name: getText(document.title),
      mandatory_products: toNumber(window.mandatoryProducts, 0),
    };
  }

  function getSelectionCount() {
    return Array.prototype.reduce.call(document.querySelectorAll('.quantity-input'), function (total, input) {
      return total + Math.min(toNumber(input.value, 0), 1);
    }, 0);
  }

  function getElementFromCollectionItem(collectionItem) {
    if (!collectionItem) return null;
    return collectionItem.querySelector("input[type='checkbox']") || collectionItem.querySelector('.quantity-input');
  }

  function getSelectedBundleElements() {
    var root = getBundleRoot();
    if (!root) return [];

    return Array.prototype.filter.call(root.querySelectorAll("input[type='checkbox']"), function (checkbox) {
      return checkbox.checked;
    });
  }

  function getSelectedBundleItems() {
    return getSelectedBundleElements().map(function (element) {
      var collectionItem = element.closest('.collection-item');
      var quantityInput = collectionItem ? collectionItem.querySelector('.quantity-input') : null;
      var quantity = Math.min(toNumber(quantityInput && quantityInput.value, 1), 1);

      return buildItemFromElement(element, {
        quantity: quantity || 1,
      });
    }).filter(function (item) {
      return item.item_name;
    });
  }

  function buildCrazyPurchasePayload() {
    var items = getSelectedBundleItems();
    var bundle = normalizeBundle(getBundleContext());
    var value = items.reduce(function (total, item) {
      return total + (toNumber(item.price, 0) * toNumber(item.quantity, 1));
    }, 0);
    var lineItemNames = items.map(function (item) {
      return item.item_name;
    });

    return {
      event: 'crazy_purchase',
      item_name: lineItemNames.join(', '),
      items: items,
      line_item_names: lineItemNames,
      bundle: bundle,
      bundle_selection_count: items.length,
      ecommerce: {
        currency: getCurrency(),
        value: value,
        items: items,
      },
    };
  }

  function pushForElement(eventName, element, extraOptions) {
    if (!element) return;

    push(eventName, Object.assign({
      element: element,
      bundle: getBundleContext(),
      bundle_selection_count: getSelectionCount(),
    }, extraOptions || {}));
  }

  function handleViewTrigger(trigger) {
    if (!trigger) return;

    var collectionItem = trigger.closest('.collection-item');
    var element = getElementFromCollectionItem(collectionItem) || trigger;
    var item = buildItemFromElement(element, {
      item_name: getText(trigger.dataset && trigger.dataset.title),
      sku: getText(trigger.dataset && trigger.dataset.sku),
    });
    var viewKey = item.item_id + ':' + item.item_name;
    var now = Date.now();

    if (viewKey === lastViewedKey && now - lastViewedAt < 500) {
      return;
    }

    lastViewedKey = viewKey;
    lastViewedAt = now;

    push('view_item_in_bundle', {
      item: item,
      bundle: getBundleContext(),
      bundle_selection_count: getSelectionCount(),
    });
  }

  function normalizeBundle(bundle) {
    var source = bundle || {};
    return {
      bundle_id: getText(source.bundle_id),
      bundle_name: getText(source.bundle_name),
      bundle_price: normalizePrice(source.bundle_price),
      bundle_sku: getText(source.bundle_sku),
      parent_product_id: getText(source.parent_product_id),
      parent_product_name: getText(source.parent_product_name),
      mandatory_products: toNumber(source.mandatory_products, 0),
    };
  }

  function buildPayload(eventName, options) {
    var config = options || {};
    var item = config.item || buildItemFromElement(config.element, config);
    var bundle = normalizeBundle(config.bundle);
    var value = toNumber(config.value, item.price * item.quantity || 0);

    return {
      event: eventName,
      item_name: item.item_name,
      item_id: item.item_id,
      items: [item],
      bundle: bundle,
      bundle_selection_count: toNumber(config.bundle_selection_count, 0),
      ecommerce: {
        currency: getText(config.currency) || getCurrency(),
        value: value,
        items: [item],
      },
    };
  }

  function push(eventName, options) {
    var dataLayer = ensureDataLayer();
    dataLayer.push({ ecommerce: null });
    dataLayer.push(buildPayload(eventName, options));
  }

  function pushCrazyPurchase() {
    var dataLayer = ensureDataLayer();
    var payload = buildCrazyPurchasePayload();
    if (!payload.items.length) return;

    dataLayer.push({ ecommerce: null });
    dataLayer.push(payload);
  }

  function pushViewItemInBundle(options) {
    push('view_item_in_bundle', options);
  }

  function pushAddItemInBundle(options) {
    push('add_item_in_bundle', options);
  }

  function pushRemoveItemInBundle(options) {
    push('remove_item_in_bundle', options);
  }

  document.addEventListener('flexi:bundle-view-item', function (event) {
    pushViewItemInBundle(event.detail);
  });

  document.addEventListener('flexi:bundle-add-item', function (event) {
    pushAddItemInBundle(event.detail);
  });

  document.addEventListener('flexi:bundle-remove-item', function (event) {
    pushRemoveItemInBundle(event.detail);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.flexi-popup-trigger');
    if (!trigger) {
      var productGrid = event.target.closest('.product_grid_items');
      trigger = productGrid ? productGrid.closest('.collection-item')?.querySelector('.flexi-popup-trigger') : null;
    }

    if (!trigger) return;
    handleViewTrigger(trigger);
  }, true);

  document.addEventListener('click', function (event) {
    var checkbox = event.target.closest("input[type='checkbox']");
    if (!checkbox || !checkbox.closest('.flexi-box-bundle')) return;

    window.setTimeout(function () {
      pushForElement(checkbox.checked ? 'add_item_in_bundle' : 'remove_item_in_bundle', checkbox);
    }, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var minusButton = event.target.closest('.quantity-minus');
    if (!minusButton || !minusButton.closest('.flexi-box-bundle')) return;

    var collectionItem = minusButton.closest('.collection-item');
    var element = getElementFromCollectionItem(collectionItem);
    if (!element) return;

    window.setTimeout(function () {
      if (!collectionItem.querySelector("input[type='checkbox']:checked")) {
        pushForElement('remove_item_in_bundle', element);
      }
    }, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var payNowButton = event.target.closest('#flexi-pay-now, #flexi-popup-pay-now');
    var now = Date.now();

    if (!payNowButton || !payNowButton.closest('.flexi-box-bundle, .sticky_cart, .flexi-popup')) return;
    if (now - lastPayNowAt < 500) return;

    lastPayNowAt = now;
    pushCrazyPurchase();
  }, true);

  window.FlexiBundleDataLayer = {
    buildItemFromElement: buildItemFromElement,
    pushViewItemInBundle: pushViewItemInBundle,
    pushAddItemInBundle: pushAddItemInBundle,
    pushRemoveItemInBundle: pushRemoveItemInBundle,
    pushCrazyPurchase: pushCrazyPurchase,
  };
})();